// extracted by mini-css-extract-plugin
module.exports = {"Emojify":"zw_a bfq_g"};